/**
 * Take the product-card anchor back out of the URL once it has been used.
 *
 * `assets/product-tile.js` (navigateToProduct) writes the tapped card's id into
 * the current page's URL before it navigates:
 *
 *     url.hash = link.getAttribute('id');
 *     history.replaceState({}, '', url.toString());
 *
 * That is deliberate - it is how the shopper lands back on the card they tapped
 * when the browser re-fetches the page instead of serving it from bfcache. The
 * side effect is that going back leaves `https://…/#937e39cc…` in the address
 * bar, which is what gets copied and shared.
 *
 * So the anchor is removed rather than never written: after the browser has
 * finished scrolling to it, the hash has done its job and only the ugly URL is
 * left. On a bfcache restore the browser reuses its own saved scroll offset and
 * never consults the hash, so it can go immediately.
 *
 * Only a 32-hex hash that resolves to an element on the page is touched, so a
 * real anchor link - `#main`, an FAQ item, an in-page section link - is left
 * alone.
 */
(function () {
  var CARD_ID = /^[0-9a-f]{32}$/;

  function stripCardHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var id = hash.slice(1);
    if (!CARD_ID.test(id)) return;
    if (!document.getElementById(id)) return;

    var clean = window.location.pathname + window.location.search;
    window.history.replaceState(window.history.state, '', clean);
  }

  // Two frames, so the removal lands after the browser has applied its own
  // scroll for the anchor. One frame is not always enough on a cold load.
  function stripAfterScroll() {
    requestAnimationFrame(function () {
      requestAnimationFrame(stripCardHash);
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (window.Shopify && window.Shopify.designMode === true) return;

    if (event.persisted) {
      stripCardHash();
      return;
    }
    if (document.readyState === 'complete') {
      stripAfterScroll();
    } else {
      window.addEventListener('load', stripAfterScroll, {once: true});
    }
  });
})();
